<script type="ts">
    import { Accordion, Slider } from "carbon-components-svelte";
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";
    import { maxTrussHeight, SceneManagerEvent } from "../scene-manager";
    import type { BannerPositions } from "../scene-manager";
    import type SceneManager from "../scene-manager";
    import BannerItem from "./BannerItem.svelte";

    export let manager: SceneManager;

	const { getTranslation } = stores();

    const banners: {key: BannerPositions, label: string}[] = [
        {key: "front", label: $getTranslation("banner-front").value},  
        {key: "back", label: $getTranslation("banner-back").value},  
        {key: "left", label: $getTranslation("banner-left").value},  
        {key: "right", label: $getTranslation("banner-right").value},  
        {key: "center", label: $getTranslation("banner-center").value},  
    ];

    function handleTrussHeightChange(v: number) {
        manager.trussHeight = v;
    }

    let minTrussHeight = manager.height ?? 0;
    manager.addListener(SceneManagerEvent.Size, ({size: { height }}) => {
        minTrussHeight = height;
    });

</script>

<div class="banner">
    <div class="banner__section">
        <Slider
            light
            labelText={$getTranslation("banner-clearance").value}
            min={minTrussHeight}
            max={maxTrussHeight}
            minLabel={`${manager.height ?? 0}cm`}
            maxLabel={`${maxTrussHeight}cm`}
            step={50}
            value={manager?.trussHeight ?? maxTrussHeight}
            on:change={(e) => handleTrussHeightChange(e.detail)}
        />
    </div>
    <Accordion align="start">
        {#each banners as banner (banner.key)}
            <BannerItem {manager} label={banner.label} position={banner.key} />
        {/each}
    </Accordion>
</div>

<style type="text/scss">
    .banner {
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 100%;
        margin: 0 -1rem;
        position: relative;

        &__section {
            padding: 0 1rem;
        }

        :global(.bx--accordion__content) {
            margin-left: 0;
            padding-right: 1rem;
        }
        :global(.bx--slider-text-input) {
            width: 100%;
        }
        :global(.bx--slider) {
            min-width: 9.5rem;
        }
    }
</style>